import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Eye, Layers, Shield, Target } from 'lucide-react';
export function RulesSection() {
  return <section className="w-full px-4 md:px-6" data-id="element-394">
      <div className="max-w-3xl mx-auto" data-id="element-395">
        <FadeIn className="mb-16 text-center" data-id="element-396">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-397">
            La solución real:{' '}
            <span className="text-brand-gold" data-id="element-398">Reglas del Dinero</span>
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-399">
            Este manual te enseña un sistema simple y ejecutable para construir
            control.
          </p>
        </FadeIn>

        <div className="space-y-12" data-id="element-400">
          {/* Rule 1 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-401">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-402">
              1
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-403">
              Claridad absoluta
            </h3>
            <div className="flex flex-col md:flex-row gap-6" data-id="element-404">
              <div className="flex-1" data-id="element-405">
                <p className="text-brand-text mb-4" data-id="element-406">Saber exactamente:</p>
                <ul className="space-y-2 mb-4" data-id="element-407">
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-408">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-409" /> Cuánto tienes
                  </li>
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-410">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-411" /> Dónde está
                  </li>
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-412">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-413" /> Para qué sirve
                  </li>
                </ul>
                <p className="text-brand-text italic" data-id="element-414">
                  Sin claridad, tu cerebro inventa historias. Y las historias
                  cuestan dinero.
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Rule 2 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-415">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-416">
              2
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-417">
              Separación estratégica
            </h3>
            <p className="text-brand-text mb-6" data-id="element-418">
              Tu dinero se divide por función, no por emoción.
            </p>

            <div className="bg-brand-card p-6 rounded-lg border border-brand-bg" data-id="element-419">
              <h4 className="text-sm uppercase tracking-wider text-brand-muted font-bold mb-4" data-id="element-420">
                Las 4 funciones del dinero:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-421">
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-422">
                  <span className="text-brand-gold font-bold" data-id="element-423">1</span>
                  <span className="text-white" data-id="element-424">Supervivencia</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-425">
                  <span className="text-brand-gold font-bold" data-id="element-426">2</span>
                  <span className="text-white" data-id="element-427">Estabilidad</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-428">
                  <span className="text-brand-gold font-bold" data-id="element-429">3</span>
                  <span className="text-white" data-id="element-430">Crecimiento</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-431">
                  <span className="text-brand-gold font-bold" data-id="element-432">4</span>
                  <span className="text-white" data-id="element-433">Multiplicación</span>
                </div>
              </div>
              <p className="mt-4 text-center text-brand-gold font-serif italic" data-id="element-434">
                "Sin estabilidad, la multiplicación es fantasía."
              </p>
            </div>
          </FadeIn>

          {/* Rule 3 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-435">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-436">
              3
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-437">
              Rol definido antes de moverlo
            </h3>
            <p className="text-brand-text mb-4" data-id="element-438">
              Antes de gastar o invertir, decides:
            </p>
            <ul className="space-y-2 mb-4 bg-brand-card/30 p-4 rounded border-l-2 border-brand-gold" data-id="element-439">
              <li className="text-brand-text" data-id="element-440">
                ¿Este dinero puede asumir riesgo?
              </li>
              <li className="text-brand-text" data-id="element-441">¿Qué pasa si sale mal?</li>
              <li className="text-brand-text" data-id="element-442">¿Cuál es el límite?</li>
            </ul>
            <p className="text-brand-text" data-id="element-443">
              Esto corta el impulso. Y el impulso, en finanzas, es caro.
            </p>
          </FadeIn>

          {/* Implementation - 4 Accounts */}
          <FadeIn className="mt-20 pt-12 border-t border-brand-card" data-id="element-444">
            <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-445">
              “Ok… pero ¿cómo lo ejecuto en la vida real?”
            </h3>
            <p className="text-center text-brand-muted mb-10" data-id="element-446">
              Con murallas. El manual te da el mapa práctico de{' '}
              <strong className="text-white" data-id="element-447">4 cuentas esenciales</strong>:
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-448">
              {[{
              name: 'Personal',
              icon: <Target className="w-6 h-6" data-id="element-449" />
            }, {
              name: 'Operativa',
              sub: '(Negocio)',
              icon: <Layers className="w-6 h-6" data-id="element-450" />
            }, {
              name: 'Protección',
              icon: <Shield className="w-6 h-6" data-id="element-451" />
            }, {
              name: 'Inversión',
              icon: <Activity className="w-6 h-6" data-id="element-452" />
            }].map((acc, i) => <div key={i} className="flex flex-col items-center justify-center p-6 bg-brand-card rounded-lg border border-brand-gold/10 hover:border-brand-gold/50 transition-colors text-center h-32" data-id="element-453">
                  <div className="text-brand-gold mb-3" data-id="element-454">{acc.icon}</div>
                  <span className="font-bold text-white" data-id="element-455">{acc.name}</span>
                  {acc.sub && <span className="text-xs text-brand-muted mt-1" data-id="element-456">
                      {acc.sub}
                    </span>}
                </div>)}
            </div>
            <p className="text-center text-brand-muted mt-8 text-sm" data-id="element-457">
              No para complicarte. Para que un golpe no te destruya todo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}
// Helper icon component since Activity wasn't imported above but used
function Activity(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-458">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" data-id="element-459" />
    </svg>;
}